var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "block-editor send-email" }, [
    _c(
      "div",
      { key: "dynamic_" + _vm.clone.isDynamic, staticClass: "wrapper" },
      [
        _c("div", { staticClass: "title" }, [_vm._v("Select Reservation")]),
        _vm._v(" "),
        _c(
          "a-select",
          {
            attrs: { "show-search": "" },
            model: {
              value: _vm.clone.reservationPlanId,
              callback: function ($$v) {
                _vm.$set(_vm.clone, "reservationPlanId", $$v)
              },
              expression: "clone.reservationPlanId",
            },
          },
          _vm._l(_vm.reservationPlans, function (reservationPlan, index) {
            return _c(
              "a-select-option",
              { key: index, attrs: { value: reservationPlan._id } },
              [
                _vm._v(
                  "\n                " +
                    _vm._s(reservationPlan.title) +
                    "\n            "
                ),
              ]
            )
          }),
          1
        ),
        _vm._v(" "),
        _vm.clone.reservationPlanId
          ? _c(
              "div",
              { staticClass: "form-input" },
              [
                _c("div", { staticClass: "form-input-name" }, [
                  _vm._v("Dynamic Reservation"),
                ]),
                _vm._v(" "),
                _c("a-switch", {
                  model: {
                    value: _vm.clone.isDynamic,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "isDynamic", $$v)
                    },
                    expression: "clone.isDynamic",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.clone.isDynamic && _vm.clone.reservationPlanId
          ? _c(
              "div",
              { staticClass: "form-input" },
              [
                _c("div", { staticClass: "form-input-name" }, [
                  _vm._v("Reservation Date"),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: { "show-attributes": true, "show-emoji": false },
                  model: {
                    value: _vm.clone.startDate,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "startDate", $$v)
                    },
                    expression: "clone.startDate",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.clone.isDynamic && _vm.clone.reservationPlanId
          ? _c(
              "div",
              { staticClass: "form-input" },
              [
                _c("div", { staticClass: "form-input-name" }, [
                  _vm._v("Reservation Day"),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: { "show-attributes": true, "show-emoji": false },
                  model: {
                    value: _vm.clone.selectedDay,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "selectedDay", $$v)
                    },
                    expression: "clone.selectedDay",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        !_vm.clone.isDynamic && _vm.clone.reservationPlanId
          ? _c(
              "div",
              { staticClass: "form-input" },
              [
                _c("div", { staticClass: "form-input-name" }, [
                  _vm._v("Reservation Hour"),
                ]),
                _vm._v(" "),
                _c("TiptapEditor", {
                  attrs: { "show-attributes": true, "show-emoji": false },
                  model: {
                    value: _vm.clone.selectedTime,
                    callback: function ($$v) {
                      _vm.$set(_vm.clone, "selectedTime", $$v)
                    },
                    expression: "clone.selectedTime",
                  },
                }),
              ],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _vm._l(_vm.formInputs, function (formInput) {
          return _c(
            "div",
            { staticClass: "form-input" },
            [
              _c("div", { staticClass: "form-input-name" }, [
                _vm._v(_vm._s(formInput.label)),
              ]),
              _vm._v(" "),
              _c("TiptapEditor", {
                attrs: { "show-attributes": true, "show-emoji": false },
                model: {
                  value: formInput.value,
                  callback: function ($$v) {
                    _vm.$set(formInput, "value", $$v)
                  },
                  expression: "formInput.value",
                },
              }),
            ],
            1
          )
        }),
      ],
      2
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }